import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    const f = window;
    const b = document;
    const n = 'script';
    const pixelId = '691118070725783';
    if (f.fbq) return;
    const fbq = function (...args: unknown[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    if (!f._fbq) f._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as unknown[][];
    f.fbq = fbq;
    const script = b.createElement(n);
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = b.getElementsByTagName(n)[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    // Initialize and track PageView
    f.fbq('init', pixelId);
    f.fbq('track', 'PageView');
    // Add noscript pixel
    const noscript = b.createElement('img');
    noscript.height = 1;
    noscript.width = 1;
    noscript.style.display = 'none';
    noscript.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    b.body.appendChild(noscript);
    return () => {
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  return null;
}
export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Código de Sanación del Árbol',
      content_type: 'product',
      value: 11.99,
      currency: 'USD'
    });
  }
}